import React from 'react';
import Joyride, { CallBackProps, Step } from 'react-joyride';

interface ProductTourProps {
  steps: Step[];
  run: boolean;
  onCallback: (data: CallBackProps) => void;
}

export const ProductTour: React.FC<ProductTourProps> = ({ steps, run, onCallback }) => (
  <Joyride
    steps={steps}
    run={run}
    continuous
    showProgress
    showSkipButton
    disableScrollParentFix
    scrollToFirstStep
    callback={onCallback}
    locale={{ last: 'Done' }}
    styles={{
      options: {
        primaryColor: '#0066cc',
        zIndex: 10000,
        arrowColor: '#ffffff',
        backgroundColor: '#ffffff',
        textColor: '#1f2937',
      },
      tooltip: {
        borderRadius: 10,
        fontSize: '0.9rem',
      },
      buttonNext: {
        borderRadius: 6,
      },
      buttonBack: {
        color: '#6b7280',
      },
    }}
  />
);
